exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.menutable .v-datatable {\n  background: transparent !important;\n}\n.menutable .v-datatable__actions {\n  background: transparent !important;\n}\n", ""]);

